module.exports = __webpack_public_path__ + "img/complete.4af82639.svg";